var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMySafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.234 11v.011c2.925 1.507 6.36 2.231 9.234 2.435v8.547c0 2.28-.217 3.91-1.33 5.485-1.338 1.897-3.937 3.684-7.925 5.446l.021-.011v.01c-.004 0-.007-.002-.011-.004l-.01.005c-3.967-1.769-6.554-3.553-7.886-5.446C13.217 25.903 13 24.274 13 21.993v-8.548c2.876-.204 6.313-.931 9.234-2.445l-.022.011V11l.012.006.01-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    stroke: "#134A81",
    d: "M20.838 22.58l-2.393-2.389-1.318 1.316 3.711 3.71 1.171-1.17 5.306-5.309-1.316-1.318-3.99 3.99z"
  }))));
}
export default SvgMySafety;